import { render } from "./inq_info.vue?vue&type=template&id=ab00751a&scoped=true"
import script from "./inq_info.vue?vue&type=script&lang=js"
export * from "./inq_info.vue?vue&type=script&lang=js"

import "./inq_info.vue?vue&type=style&index=0&id=ab00751a&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab00751a"]])

export default __exports__